import i18n from 'i18next';
import isEmail from 'validator/lib/isEmail';

export default function validateEmail(email) {
  let message = '';
  let success = false;

  if (!email) {
    message = i18n.t('validateEmail-requiredErrorMessage');
    // eslint-disable-next-line camelcase
  } else if (!isEmail(email, { allow_utf8_local_part: false })) {
    message = i18n.t('validateEmail-invalidErrorMessage');
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}
